<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Status da Visita:"
    id="selectTipoEvento"
    placeholder="Selecione o status da visita"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isRequired="true"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectStatusVisita',
  mixins: [useReactiveModelMixin('value')],
  data () {
    return {
      listOptions: [
        { text: 'EM ANDAMENTO', value: '1' },
        { text: 'FINALIZADO', value: '3' },
        { text: 'GANHO', value: '2' },
        { text: 'PERDIDO', value: '0' }
      ],
      selected: null
    }
  },
  created () {},
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectStatusVisita.vue